<template>   
    <tr v-bind:class="'row-' + rowIndex">
        <template v-for="column in columns">
            <!-- { 'fixed' : isFixedColumn(column.id) }, {'fixed-last' : isFixedColumnLast(column.id)} -->
            <td v-for="cell, cellIndex in row.cells[column.id]" 
                :key="'tbody-' + column.id + cellIndex"
                v-bind:class="['cell-' + cellIndex, 'column-' + column.id, getMetaValue(cell, 'attributes.classes'), getMetaValue(column, 'attributes.classes', []) ]"
                v-bind:colspan="getMetaValue(cell, 'attributes.colspan', 1)"
                v-bind:rowspan="getMetaValue(cell, 'attributes.rowspan', 1)"
            >
                <template v-if="isComponent(cell)">
                    <component 
                        v-bind:is="importComponent(cell)"
                        :namespace="namespace"
                        :cell="cell"
                        :cellIndex="cellIndex"
                    />
                </template>
                <template v-else>
                    <template v-if="isArray(cell.value)">
                        {{ cell.value.join(', ') }}
                    </template>
                    <template v-else>
                        {{ cell.toString() }}
                    </template>                    
                </template>
            </td>
        </template>
    </tr>            
</template>

<style lang="scss" scoped>
    @import "./style.scss";
</style>

<script>
    
    import _ from "lodash";
    import internalMixin from './mixin/internal.mixin.js';


    export default {
        name: "table-row",

        mixins: [
            internalMixin
        ],

        props: {

            namespace: {
                type: String,
                required: false,
                default: ''
            },

            row: {
                type: Object,
                required: true
            },  
            
            rowIndex: {
                type: Number,
                required: true
            },
        },        

        created() {
            this.setTableStoreNamespacePrefix(this.namespace);
        },

        methods: {
            isArray: function(value) {
                return _.isArray(value);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/common/table_v3/TableRow.vue